// components/regular-user-create/regular-user-create.component.ts
import {ChangeDetectionStrategy, Component, inject, output} from '@angular/core';
import {UserModel} from '@core/api/data-access';
import {UserStore} from '@data-users';
import {TranslateModule} from '@ngx-translate/core';
import {of, take} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {UserFormModel} from '../../models/user-form.model';
import {UserFormComponent} from '../user-form/user-form.component';

@Component({
	selector: 'dc-regular-user-create',
	imports: [TranslateModule, UserFormComponent],
	template: `
		<dc-user-form
			(formSubmit)="onFormSubmit($event)"
			(formCancel)="onFormCancel()"
			formSubmitButtonText="dccomp.user-form.saveButton"
			formCancelButtonText="dccomp.user-form.cancelButton"
			[sections]="['GeneralDetails', 'ContactInfo', 'Password', 'Permissions']"
		/>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegularUserCreateComponent {
	private readonly userStore = inject(UserStore);

	public submitUser = output<UserModel | null>();
	public cancelForm = output<void>();

	public onFormSubmit(userFormModel: UserFormModel): void {
		this.userStore
			.createUser(userFormModel.userModel, userFormModel.password)
			.pipe(
				catchError(error => {
					console.error(error);
					return of(null);
				}),
				take(1),
			)
			.subscribe(user => {
				if (user) {
					this.submitUser.emit(user);
				} else {
					this.submitUser.emit(null);
				}
			});
	}

	public onFormCancel(): void {
		this.cancelForm.emit();
	}
}
